<!--
  About Us Component ("O nas")

  Header (overline + heading), a supporting rich-text body and two side-by-side
  images. Colors derive from `site_context` so the block stays consistent within
  each clinic. Max content width is 1200px (Figma node 6712:5766).
-->
<template>
  <section class="flex flex-col items-center justify-center overflow-x-hidden px-4 py-12 relative w-full bg-white md:px-16 lg:py-16">
    <div class="about-us mx-auto flex w-full min-w-0 max-w-[1200px] flex-col gap-6 lg:gap-8">
      <div class="flex min-w-0 flex-col gap-1">
        <p
          v-if="overlineText"
          class="text-[14px] font-semibold uppercase leading-5 tracking-[1px]"
        >
          {{ overlineText }}
        </p>
        <h2
          class="break-words text-[32px] font-medium leading-10 tracking-[-0.64px] lg:text-[36px] lg:leading-[44px] lg:tracking-[-0.72px]"
        >
          {{ headingText }}
        </h2>
      </div>

      <!-- eslint-disable-next-line vue/no-v-html -->
      <div
        v-if="bodyText"
        class="about-us-prose min-w-0 max-w-none overflow-x-hidden text-dark"
        v-html="bodyText"
      />

      <div
        v-if="image1 || image2"
        class="grid min-w-0 grid-cols-1 gap-6"
        :class="image1 && image2 ? 'md:grid-cols-2 md:gap-8' : ''"
      >
        <img
          v-if="image1"
          :src="image1"
          :alt="image1Alt || headingText"
          class="h-[240px] w-full rounded-[12px] object-cover md:h-[460px]"
        >
        <img
          v-if="image2"
          :src="image2"
          :alt="image2Alt || headingText"
          class="h-[240px] w-full rounded-[12px] object-cover md:h-[460px]"
        >
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  overlineText: { type: String, default: '' },
  headingText:  { type: String, default: 'O nas' },
  bodyText:     { type: String, default: '' },
  image1:       { type: String, default: '' },
  image1Alt:    { type: String, default: '' },
  image2:       { type: String, default: '' },
  image2Alt:    { type: String, default: '' },
  // eslint-disable-next-line vue/prop-name-casing
  site_context: { type: String, default: null },
});
</script>

<style scoped>
.about-us-prose {
  max-width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.about-us-prose :deep(p) {
  margin-bottom: 1.25rem;
}

.about-us-prose :deep(pre) {
  max-width: 100%;
  overflow-x: auto;
}

.about-us-prose :deep(pre code) {
  white-space: pre-wrap;
}

.about-us-prose :deep(table) {
  display: block;
  max-width: 100%;
  overflow-x: auto;
}

.about-us-prose :deep(strong) {
  font-weight: 700;
}

.about-us-prose :deep(img) {
  max-width: 100%;
  height: auto;
}
</style>
